import {
    selectCustomerConfig,
    setGigakombi,
} from 'Container/App/slice';
import { useDispatch } from '../store';
import { startAppListening } from 'Container/App/listener';
import { createComponentById } from '@vfde-brix/ws10/core';
import { createOptionPicker } from '@vfde-brix/ws10/option-picker';
import { GIGAKOMBI_OPTION_PICKER_CONTAINER } from 'Container/App/constants';

/**
 * Mount gigakombi option picker
 */
const mountGigakombiOptionPicker = () => {
    const dispatch = useDispatch();

    const onChange = (event: Event) => {
        const target = event.target as HTMLInputElement;

        dispatch(setGigakombi(target.value === 'true'));
    };

    const gigakombiPicker = createComponentById(createOptionPicker, GIGAKOMBI_OPTION_PICKER_CONTAINER, { onChange });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectCustomerConfig(currentState).hasGigakombi !== selectCustomerConfig(previousState).hasGigakombi,
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const customerConfig = selectCustomerConfig(api.getState());

            gigakombiPicker?.setValue(`${customerConfig.hasGigakombi}`);
        },
    });

    return gigakombiPicker;
};

export default mountGigakombiOptionPicker;
